import { create } from 'store/create';

export type GridCitationSelectionMode = 'off' | 'add-multiple';

export interface GridCitationSelectionItem {
  id: string;
  alias: string;
  columnId: string | number;
  key?: string;
}

interface GridCitationSelectionStore {
  mode: GridCitationSelectionMode;
  selected: GridCitationSelectionItem[];
  enterAddMultiple: () => void;
  exit: () => void;
  toggle: (item: GridCitationSelectionItem) => void;
}

const useGridCitationSelectionStore = create<GridCitationSelectionStore>()(set => ({
  mode: 'off',
  selected: [],
  enterAddMultiple: () => set(() => ({ mode: 'add-multiple' })),
  exit: () => set(() => ({ mode: 'off', selected: [] })),
  toggle: item =>
    set(state => {
      const selected = state.selected.filter(entry => entry.id !== item.id);
      if (selected.length === state.selected.length) {
        selected.push(item);
      }
      return { selected, mode: selected.length ? state.mode : 'off' };
    }),
}));

export default useGridCitationSelectionStore;
